import request from '@/utils/request'

// 查询新品预测列表
export function apiFcNewProductList (query) {
    return request({
      url: '/scp/fcNewProduct/list',
      method: 'get',
      params: query
    })
  }
  // 查询新品预测列表
export function apiFcNewProductMonthList (query) {
  return request({
    url: '/scp/fcNewProduct/monthList',
    method: 'get',
    params: query
  })
}
  // 查询新品预测列表
export function apiPostFcNewProductList (data) {
    return request({
      url: '/scp/fcNewProduct',
      method: 'post',
      data: data
    })
  }
    // 查询新品预测列表
export function apiFcNewProductDetailList (query) {
  return request({
    url: '/scp/fcNewProductDetail/list',
    method: 'get',
    params: query
  })
}
  // /修改新品预测
  export function apiFcNewProductDetail (data) {
    return request({
      url: `/scp/fcNewProductDetail`,
      method: 'put',
      data: data
    })
  }
  // 删除期初发货比例 scpSopFcInitialDeliveryRatio/{ids}
  export function apiDelFcNewProductDetail (data) {
    return request({
      url: `/scp/fcNewProductDetail`,
      method: 'delete',
      data: data
    })
  }
    // /修改供应商产能
    export function apiScpSopSupplierCapacity (data) {
      return request({
        url: `/scp/scpSopSupplierCapacity`,
        method: 'put',
        data: data
      })
    }
export function apiScpSopSupplierCapacityUpdateCapacity (data) {
  return request({
    url: `/scp/scpSopSupplierCapacity/updateCapacity`,
    method: 'put',
    data: data
  })
}
    // /修改供应商产能
    export function scpDelSopSupplierCapacity (ids) {
      return request({
        url: `/scp/scpSopSupplierCapacity/${ids}`,
        method: 'delete'
      })
    }
    // 删除列表
    export function scpDelSProduct (data) {
      return request({
        url: `/scp/fcNewProduct`,
        method: 'delete',
        params: data
      })
    }
